import {createReducer, on} from '@ngrx/store';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {
  clearProductionInstanceTypesState,
  loadProductionInstanceTypes,
  loadProductionInstanceTypesFailure,
  loadProductionInstanceTypesSuccess
} from './organization-account.production-instance-types.actions';


export interface State {
  record: InstanceType[];
  error: any;
  loaded: boolean;
  loading: boolean;
  region: RegionCode | null;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
  region: null
};


export const loadProductionInstanceTypesReducer = createReducer(
  initialState,

  on(loadProductionInstanceTypes, (state: State, action: {region: RegionCode}): State => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
    region: action.region
  })),
  on(loadProductionInstanceTypesSuccess, (state: State, action: {data: InstanceType[]}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
    region: state.region
  })),
  on(loadProductionInstanceTypesFailure, (state: State, action: {error: any}): State => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false,
    region: state.region
  })),
  on(clearProductionInstanceTypesState, (): State => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
    region: null
  }))
);
